module.exports = __webpack_public_path__ + "static/media/Logo_ShapYa_Red.8d94e08c.png";